





















// @ts-ignore
import v8n from 'v8n';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { bookingModule } from '@/store';
import { Route } from 'vue-router';

@Component({
  components: {},
})
export default class extends Vue {
  mounted() {
    bookingModule.setCurrentStep(8);
    bookingModule.checkStatus();
  }

  beforeRouteLeave(to: Route, from: Route, next: (args?: any) => void) {
    bookingModule.newBooking();
    next();
  }
}
